export default __webpack_public_path__ + "static/featured-adornment-4519fdac0329cfdf3cd82ce52f6085c0.svg";